<script setup lang="ts">
import { ref } from 'vue'
import { defaultColor } from '@/enums/defaultColor'
interface Props {
  title: string
  label: string
  delay?: number
  colorState?: defaultColor
}

const props = withDefaults(defineProps<Props>(), {
  delay: 3000
})

const showing = ref<boolean>(true)
setTimeout(() => {
  showing.value = false
}, props.delay)
</script>
<template>
  <div class="w-screen h-[200px] absolute right-0 overflow-x-hidden">
    <div
      class="p-[16px] w-[364px] lg:w-[592px] bg-[#444444] text-white border-l-[8px] rounded-[8px] absolute z-1000"
      :class="[
        showing ? 'notif-in right-[10px] lg:right-[32px]' : 'notif-out left-[100vw]',
        colorState === defaultColor.PRIMARY ? 'border-[--algo-system-green-600]' : '',
        colorState === defaultColor.SECONDARY ? 'border-[--algo-system-blue-600]' : '',
        colorState === defaultColor.DANGER ? 'border-[--algo-system-red-600]' : '',
        colorState === defaultColor.WARNING ? 'border-[--algo-system-yellow-500]' : '',
        colorState === defaultColor.GRAY ? 'border-[--algo-system-zinc-600]' : ''
      ]"
    >
      <div class="flex flex-row gap-[8px]">
        <div>
          <slot name="title-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              v-show="(colorState as defaultColor) === defaultColor.WARNING"
            >
              <path
                d="M18.5001 14.6946L11.6681 2.82974C11.4973 2.53906 11.2536 2.29803 10.961 2.13057C10.6685 1.9631 10.3372 1.875 10.0001 1.875C9.66299 1.875 9.33174 1.9631 9.03916 2.13057C8.74659 2.29803 8.50286 2.53906 8.33214 2.82974L1.50011 14.6946C1.33584 14.9757 1.24927 15.2955 1.24927 15.6211C1.24927 15.9468 1.33584 16.2665 1.50011 16.5477C1.66865 16.8401 1.91196 17.0825 2.20508 17.2498C2.49819 17.4172 2.83056 17.5036 3.16807 17.5001H16.8321C17.1694 17.5033 17.5014 17.4168 17.7942 17.2494C18.0871 17.0821 18.3301 16.8399 18.4985 16.5477C18.663 16.2667 18.7499 15.947 18.7502 15.6214C18.7504 15.2957 18.6641 14.9759 18.5001 14.6946ZM9.37511 8.12505C9.37511 7.95929 9.44095 7.80032 9.55816 7.68311C9.67537 7.5659 9.83434 7.50005 10.0001 7.50005C10.1659 7.50005 10.3248 7.5659 10.442 7.68311C10.5593 7.80032 10.6251 7.95929 10.6251 8.12505V11.2501C10.6251 11.4158 10.5593 11.5748 10.442 11.692C10.3248 11.8092 10.1659 11.8751 10.0001 11.8751C9.83434 11.8751 9.67537 11.8092 9.55816 11.692C9.44095 11.5748 9.37511 11.4158 9.37511 11.2501V8.12505ZM10.0001 15.0001C9.81469 15.0001 9.63343 14.9451 9.47926 14.8421C9.32509 14.739 9.20493 14.5926 9.13397 14.4213C9.06301 14.25 9.04445 14.0615 9.08062 13.8797C9.11679 13.6978 9.20608 13.5308 9.33719 13.3996C9.4683 13.2685 9.63535 13.1792 9.81721 13.1431C9.99907 13.1069 10.1876 13.1255 10.3589 13.1964C10.5302 13.2674 10.6766 13.3875 10.7796 13.5417C10.8826 13.6959 10.9376 13.8771 10.9376 14.0626C10.9376 14.3112 10.8388 14.5496 10.663 14.7255C10.4872 14.9013 10.2487 15.0001 10.0001 15.0001Z"
                fill="#FEFEFE"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              v-show="(colorState as defaultColor) === defaultColor.PRIMARY"
            >
              <path
                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM13.5672 8.56719L9.19219 12.9422C9.13415 13.0003 9.06522 13.0464 8.98934 13.0779C8.91347 13.1093 8.83214 13.1255 8.75 13.1255C8.66787 13.1255 8.58654 13.1093 8.51067 13.0779C8.43479 13.0464 8.36586 13.0003 8.30782 12.9422L6.43282 11.0672C6.31554 10.9499 6.24966 10.7909 6.24966 10.625C6.24966 10.4591 6.31554 10.3001 6.43282 10.1828C6.55009 10.0655 6.70915 9.99965 6.875 9.99965C7.04086 9.99965 7.19992 10.0655 7.31719 10.1828L8.75 11.6164L12.6828 7.68281C12.7409 7.62474 12.8098 7.57868 12.8857 7.54725C12.9616 7.51583 13.0429 7.49965 13.125 7.49965C13.2071 7.49965 13.2884 7.51583 13.3643 7.54725C13.4402 7.57868 13.5091 7.62474 13.5672 7.68281C13.6253 7.74088 13.6713 7.80982 13.7027 7.88569C13.7342 7.96156 13.7504 8.04288 13.7504 8.125C13.7504 8.20712 13.7342 8.28844 13.7027 8.36431C13.6713 8.44018 13.6253 8.50912 13.5672 8.56719Z"
                fill="#FEFEFE"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              v-show="(colorState as defaultColor) === defaultColor.SECONDARY"
            >
              <path
                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z"
                fill="#FEFEFE"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              v-show="(colorState as defaultColor) === defaultColor.DANGER"
            >
              <path
                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM12.9422 12.0578C13.0003 12.1159 13.0463 12.1848 13.0777 12.2607C13.1092 12.3366 13.1254 12.4179 13.1254 12.5C13.1254 12.5821 13.1092 12.6634 13.0777 12.7393C13.0463 12.8152 13.0003 12.8841 12.9422 12.9422C12.8841 13.0003 12.8152 13.0463 12.7393 13.0777C12.6634 13.1092 12.5821 13.1253 12.5 13.1253C12.4179 13.1253 12.3366 13.1092 12.2607 13.0777C12.1848 13.0463 12.1159 13.0003 12.0578 12.9422L10 10.8836L7.94219 12.9422C7.88412 13.0003 7.81518 13.0463 7.73931 13.0777C7.66344 13.1092 7.58213 13.1253 7.5 13.1253C7.41788 13.1253 7.33656 13.1092 7.26069 13.0777C7.18482 13.0463 7.11588 13.0003 7.05782 12.9422C6.99975 12.8841 6.95368 12.8152 6.92226 12.7393C6.89083 12.6634 6.87466 12.5821 6.87466 12.5C6.87466 12.4179 6.89083 12.3366 6.92226 12.2607C6.95368 12.1848 6.99975 12.1159 7.05782 12.0578L9.11641 10L7.05782 7.94219C6.94054 7.82491 6.87466 7.66585 6.87466 7.5C6.87466 7.33415 6.94054 7.17509 7.05782 7.05781C7.17509 6.94054 7.33415 6.87465 7.5 6.87465C7.66586 6.87465 7.82492 6.94054 7.94219 7.05781L10 9.11641L12.0578 7.05781C12.1159 6.99974 12.1848 6.95368 12.2607 6.92225C12.3366 6.89083 12.4179 6.87465 12.5 6.87465C12.5821 6.87465 12.6634 6.89083 12.7393 6.92225C12.8152 6.95368 12.8841 6.99974 12.9422 7.05781C13.0003 7.11588 13.0463 7.18482 13.0777 7.26069C13.1092 7.33656 13.1254 7.41788 13.1254 7.5C13.1254 7.58212 13.1092 7.66344 13.0777 7.73931C13.0463 7.81518 13.0003 7.88412 12.9422 7.94219L10.8836 10L12.9422 12.0578Z"
                fill="#FEFEFE"
              />
            </svg>
          </slot>
        </div>
        <div class="text-[16px] lg:text-[20px] font-semibold">{{ props.title }}</div>
      </div>
      <div class="text-[12px] lg:text-[14px]">
        {{ props.label }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.notif-in {
  animation: slideInFromRight 0.5s;
  animation-direction: normal;
}
.notif-out {
  animation: slideOutToRight 0.5s;
  animation-direction: normal;
}

@media only screen and (max-width: 1023px) {
  @keyframes slideInFromRight {
    0% {
      left: calc(100vw * 1);
    }
    100% {
      left: calc(100vw - 364px - 10px);
    }
  }
  @keyframes slideOutToRight {
    0% {
      left: calc(100vw - 364px - 10px);
    }
    100% {
      left: calc(100vw * 1);
    }
  }
}
@media only screen and (min-width: 1024px) {
  @keyframes slideInFromRight {
    0% {
      left: calc(100vw * 1);
    }
    100% {
      left: calc(100vw - 592px - 32px);
    }
  }
  @keyframes slideOutToRight {
    0% {
      left: calc(100vw - 592px - 32px);
    }
    100% {
      left: calc(100vw * 1);
    }
  }
}
</style>
